import React, {useImperativeHandle, useMemo, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import DialogContent from 'components/atoms/Dialogs/DialogContent/DialogContent';
import DialogHeader from 'components/molecules/Dialogs/DialogHeader/DialogHeader';
import CollectionSourcesSectionPanel
  from 'components/organisms/SectionPanels/CollectionSourcesSectionPanel/CollectionSourcesSectionPanel';
import StyledSourceSelectionDialog
  from 'components/organisms/Dialogs/SourceSelectionDialog/SourceSelectionDialog.styles';

const SourceSelectionDialog = React.forwardRef((props, ref) => {
  const {
    title,
    subtitle,
    onSubmit,
    onError,
    collection,
    ...innerProps
  } = useComponentProps({
    multiple: true,
    ...props
  }, 'SourceSelectionDialog');

  const innerRef = useRef(null);
  const [adding, setAdding] = useState(false);

  useImperativeHandle(ref, () => innerRef.current);

  const sections = useMemo(() => {
    return [
      {
        name: 'createSource',
        position: 2,
        title: 'Create source',
        variant: 'standard'
      },
      {
        name: 'databaseSource',
        position: 4,
        title: 'Sources database',
        variant: 'standard'
      }
    ];
  }, []);

  const handleDialog = (open) => {
    setAdding(open);
  }

  return <StyledSourceSelectionDialog ref={innerRef} {...innerProps} hide={adding}>
    <DialogHeader title={title ?? 'Add source'}
                  subtitle={subtitle} />
    <DialogContent>
      <CollectionSourcesSectionPanel className="CollectionSourceProfileCardContent-newSource"
                                     collection={collection}
                                     sectionDefinitions={sections}
                                     onDialog={handleDialog}
                                     onError={onError}
                                     onSubmit={onSubmit}/>
    </DialogContent>
  </StyledSourceSelectionDialog>
});

SourceSelectionDialog.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onSubmit: PropTypes.func,
  collection: PropTypes.object
};

export default SourceSelectionDialog;
